import { defineComponent as _defineComponent } from 'vue'
import { copyToClipboard } from '@/utils/clipboard';
import { toastService } from '@/library-services/toast.service';
import i18n from '@/i18n';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericKeyCopyModal',
  props: {
    value: null,
    title: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { value: string | null, title: string, loading: boolean };



const { t } = useI18n();

function copyKey() {
  try {
    copyToClipboard(props.value!);
    toastService.success(i18n.t('action.clipboard').toString());
  } catch (e) {
    toastService.error(`${e}`);
  }
}

return { __sfc: true,props, t, copyKey }
}

})